import { AnimatePresence } from "framer-motion"
import React from "react"

import { AutodiagnosticFiles } from "./AutodiagnosticFiles/AutodiagnosticFiles"
import * as Styles from "./AutodiagnosticResultView.styles"
import { ContactModal } from "./ContactModal/ContactModal"
import { Component } from "../../../../../utilities/types"
import { useSensidiagContext } from "../../../../autodiagnostic/SensidiagProvider"

export const AutodiagnosticResultView: Component = () => {
  const [ isContactModelOpen, setIsContactModelOpen ] = React.useState(false)

  const {
    endAutodiagnosticSession,
    currentProfil,
    startAutodiagnosticSession,
    module,
  } = useSensidiagContext()

  React.useEffect(() => {
    endAutodiagnosticSession()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!currentProfil) {
    return null
  }

  return (
    <Styles.ViewContainer>
      <Styles.ContentContainer>
        <Styles.Content
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 50 }}
        >
          <Styles.ProfilTitle>
            {currentProfil.title}
          </Styles.ProfilTitle>
          <Styles.Text dangerouslySetInnerHTML={{ __html: currentProfil.description }}/>
          {currentProfil.ctaLink && (
            <Styles.CtaButton onClick={() => window.open(currentProfil.ctaLink, "_blank")}>
              {currentProfil.ctaName || "Découvrir"}
            </Styles.CtaButton>
          )}
        </Styles.Content>
        {currentProfil.imageUrl &&
          <Styles.Profil src={currentProfil.imageUrl}/>
        }
      </Styles.ContentContainer>
      {module?.contactFeature && (
        <Styles.ContactButton
          onClick={() => setIsContactModelOpen(true)}
        >{module?.contactModalCtaName || "Participer au concours !"}
        </Styles.ContactButton>
      )}
      <AutodiagnosticFiles/>
      <Styles.Button onClick={() => startAutodiagnosticSession(-1)}>
        Terminer
      </Styles.Button>
      <AnimatePresence>
        {isContactModelOpen && (
          <ContactModal onClose={() => {
            startAutodiagnosticSession(-1)
            setIsContactModelOpen(false)
          }}/>
        )}
      </AnimatePresence>
    </Styles.ViewContainer>
  )
}

